import Media from '@/components/media';
import { Header3, P1, P2 } from '@bumble/ui-kit';
import Link from 'next/link';

import styles from './thumbnail.module.scss';

interface Props {
  title: string;
  excerpt: string;
  image: any;
  metIn?: string;
  secondaryInfo?: string;
  buttonText?: string;
  slug: string;
  fixedHeight?: boolean;
}

export default function Thumbnail({
  title,
  excerpt = '',
  image,
  metIn,
  secondaryInfo = '',
  buttonText = 'Read more',
  slug,
  fixedHeight = true,
}: Props) {
  return (
    <article className={styles.thumbnail}>
      <div className={styles.inner}>
        <div className={`${styles.image} ${fixedHeight ? styles.fixed__height : ''}`}>
          <Media media={image} fill={fixedHeight} />

          <div className="gradient" />

          <div className={styles.title}>
            <Header3 color="brand">{title}</Header3>
            {metIn && <P1 color="brand">{metIn}</P1>}
          </div>
        </div>

        <div className={styles.copy}>
          <div className={styles.excerpt}>{excerpt && <P1>{excerpt}</P1>}</div>
          <div className={styles.secondary_info}>{secondaryInfo && <P2>{secondaryInfo}</P2>}</div>

          {slug && (
            <div className={styles.button}>
              <Link href={`/stories/${slug}`}>{buttonText}</Link>
            </div>
          )}
        </div>
      </div>
    </article>
  );
}
